
export var RequestModes = {
    SEARCH: 'Search',
    UPDATE: 'UPDATE'
};


export function RequestCriteria (logId, filterReportId, searchCriteria, latest){
    this.activeOnly = false;
    this.logId = logId;
    this.report = filterReportId;
    this.page = searchCriteria ?  searchCriteria.page : 0;
    this.size = searchCriteria ? searchCriteria.size : 10;
    this.startDate = searchCriteria ? searchCriteria.fromDate : null;
    this.endDate = searchCriteria ? searchCriteria.thruDate : null;
    this.searchTerm = searchCriteria ? searchCriteria.searchTerm : null;
    this.sort = null;
    this.mode = RequestModes.SEARCH;
    this.latest = latest;
}